import styled from 'styled-components';

export const List = styled.ul({
  listStyleType: 'none',
  padding: 0,
  margin: 0,
  overflowY: 'auto',
  flex: 1,
  boxSizing: 'border-box',
});

interface ListItemProps {
  isHighlighted?: boolean;
}

export const ListItem = styled.li<ListItemProps>(({ isHighlighted, theme }) => ({
  textAlign: 'left',
  padding: '16px 24px',
  borderTop: `1px solid ${theme.colors.neutral['200']}`,
  background: isHighlighted ? theme.colors.neutral['100'] : theme.colors.bg,
  cursor: 'pointer',
  userSelect: 'none',
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'center',
  gap: 16,

  '&:first-of-type': {
    borderTop: 'none',
  },
}));

export const AsyncStateItem = styled.li(({ theme }) => ({
  display: 'grid',
  placeContent: 'center',
  height: '100%',
  padding: '16px 24px',
  background: theme.colors.bg,
  boxSizing: 'border-box',
}));
